import classes from './about.module.css';
const bar = (props)=>{
    const bar_width = `${props.per}%`;
    console.log(bar_width);
    let level = null;
    if(props.per>=50){
        level = (
             <span>{props.name}{}</span>
        )
    }
    return(
          <div class={classes.bar}>
              <div className={classes.boxwrapper} style={{'width':bar_width}}>
                    <span>
                        <img src={props.icon} className={classes.baricon}  alt="icons" />
                    </span>
                    {
                       level

                    }
                    
              </div>

          </div>
    )
}


export default bar;